export enum ActionButtonType {
  BUTTON = 'button',
  BUTTON_FILE_UPLOAD = 'buttonFileUpload',
  MENU = 'menu',
  GROUP = 'group',
  ICON = 'icon',
}
